// extracted by mini-css-extract-plugin
export default {"submain":"notification_submain__kgS1I","title":"notification_title__b3ei3","subtitle":"notification_subtitle__Rqn9Y","close":"notification_close__qgvz-"};